export default {
  advancedSelect: {
    placeholder: '请选择',
    copyTooltip: '复制选中内容',
    emptyText: '暂无数据',
    loadingText: '搜索中...',
    retry: '重试',
    searchFailed: '搜索失败',
    unknownError: '未知错误',
    maxRetriesReached: '已达到最大重试次数',
    noCopyContent: '没有可复制的内容',
    copySuccess: '复制成功: {content}',
    copyFailed: '复制失败'
  }
}
